import {
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY,
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEED,
  FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED,
  FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED,
} from '../actions/order_transaction_history/action_types';
import utils from '../../common/utils';

export default (
  state = {
    orderTransactions: [],
    orderPairs: [],
    totalCount: 0,
  }, action,
) => {
  switch (action.type) {
    // Fetch filter pairs
    case FETCH_FILTER_ORDER_TRANSACTION_HISTORY:
      return {
        ...state,
      };
    case FETCH_FILTER_ORDER_TRANSACTION_HISTORY_SUCCEED:
      window._.forEach(action.params.data, (orderTrans) => {
        orderTrans.key = orderTrans.id;
        orderTrans.pair = `${orderTrans.coin}/${orderTrans.currency}`;
        orderTrans.amount = utils.formatCurrency(orderTrans.amount);
        orderTrans.quantity = utils.formatCurrency(orderTrans.quantity);
        orderTrans.fee = utils.formatCurrency(orderTrans.fee);
      });
      return {
        ...state,
        orderTransactions: action.params.data,
        totalCount: action.params.totalCount,
      };
    case FETCH_USER_ORDER_TRANSACTION_HISTORY_SUCCEED:
      window._.forEach(action.params.data, (orderTrans) => {
        // orderTrans.key = orderTrans.id;
        orderTrans.pair = `${orderTrans.coin}/${orderTrans.currency}`;
        orderTrans.amount = utils.formatCurrency(orderTrans.amount);
        orderTrans.quantity = utils.formatCurrency(orderTrans.quantity);
        orderTrans.fee = utils.formatCurrency(orderTrans.fee);
      });
      return {
        ...state,
        orderTransactions: action.params.data,
        totalCount: action.params.totalCount,
      };
    case FETCH_FILTER_ORDER_TRANSACTION_HISTORY_FAILED:
      return {
        ...state,
      };
    default:
      return {
        ...state,
      };
  }
};
